import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";//NGX-TRANSLATE
import {AbstractControl,ValidatorFn} from "@angular/forms";
import moment from 'moment';
import {MatCalendarCellClassFunction} from '@angular/material/datepicker';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  API_URL = 'https://yow.herokuapp.com';  // Url del sito
  PRIVACY_URL = 'https://www.yourownwall.org/privacy';
  TERMS_URL = 'https://www.yourownwall.org/tos';
  PIC_URL ="https://yowbucket.s3.eu-south-1.amazonaws.com/";
  IMG_FOLDER = './assets/images/';



  API_PROC= "";
  API_wsPgini = "";
  APP_VERSION = '1.01';
  //API_PROC= '/regolo/appmais/ws/';             // Percorso delle API specifiche della procedura
  //API_wsPgini = '<pgini>maisoli</pgini>';     // Nome App da eseguire sul Server
  //DATE_VERSION = '28/05/2020';
  //EMAIL_APP = 'regolorex@gmail.com';
  //WEB_APP = 'https://www.pigmaprojects.it';
  //DSWEB_APP = 'www.rpa-service.com';
  //PHONE_APP = '+39 081 7762018';
  //IMG_SRC= '/regolo/public/pgdatiXmaisoli/appimages/';             // Percorso src IMMAGINI
  //IMG_URL=this.API_URL+this.IMG_SRC;
  DEFAULT_IdLanguage = 2;//NGX-TRANSLATE Lingua di Default
  DEFAULT_LanguageFamily = 'en';//NGX-TRANSLATE Lingua di Default
  DEFAULT_LanguageTag = 'en-EN';//NGX-TRANSLATE Lingua di Default
  CURRENT_IdLanguage:number=2;//NGX-TRANSLATE Lingua in uso da parte dell'utente loggato
  CURRENT_LanguageFamily:any='en';//NGX-TRANSLATE Lingua in uso da parte dell'utente loggato
  CURRENT_LanguageTag:any;//NGX-TRANSLATE Lingua in uso da parte dell'utente loggato

  AUTH_REQ="S";//E' RICHIESTA L'AUTENTICAZIONE SEMPRE
  AUTH_BIOMETRIC = 'S';//SE ATTIVA, SI PUO' UTILIZZARE L'AUTENTICAZIONE BIOMETRICA

  //exprPulsBack = 'Torna';//Esempio senza NGX-TRANSLATE in html {{env.exprPulsBack}}

  //E' il valore del filtro nelle Ricerche
  searchString: any;  
  setSearchString(searchString: any) {this.searchString = searchString;}
  getSearchString() {return this.searchString;}

  //Nella navigazione è la pagina richiesta
  GoToPage: any;  
  setGoToPage(GoToPage: any) {this.GoToPage = GoToPage;}
  getGoToPage() {return this.GoToPage;}
  wsItemsPerPage: any; 

  //Form error Messages
  FeM_required='ErrObbligatorio';
  FeM_minLength='ErrInfMin';
  FeM_maxLength='ErrSupMax';
  FeM_email='ErrNonValido';
  FeM_pattern_telefono='ErrNonValido';
  FeM_pattern_cap='ErrNonValido';
  FeM_pattern_data='ErrDataNonValida';
  FeM_pattern_time='ErrOraNonValida';
  FeM_pattern_anno='ErrAnnoNonValido';
  FeM_pattern_cdfisc='ErrCdFisc';
  FeM_min_data='ErrDataMin';
  FeM_max_data='ErrDataMax';
  FeM_fin_data='ErrDataFin';
  FeM_password='ErrPasswordPattern';
  FeM_wrongPasswordMatch='ErrPasswordMatch';

  FeM_ErrCodEsiste='ErrCodEsiste';
  FeM_ErrOldPassword='ErrOldPassword';

  pattern_telefono='^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$';
  pattern_mobile = '^((\\+?)|0)?[0-9]{0,20}$';
  pattern_email='^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$';//Non Utlizzato (vedi FeM_email)
  pattern_emailMin = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";//Non Utlizzato (vedi FeM_email) //solo minuscole
  pattern_cap='^[0-9]{5}(?:-[0-9]{4})?$';
  pattern_data='^[0-9]{2}[\/\.-]{1}[0-9]{2}[\/\.-]{1}[0-9]{4}$';
  pattern_data4='^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$';
  pattern_time='^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$';
  pattern_Cdfisc_it='^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$';

  pattern_password1 = "^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,12}$";//Esempio
  //letters (both uppercase and lowercase) and numbers validation
  pattern_password2 = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$";
  //atleast 8 letters one lowercase and one uppercase letter one digit and one special character
  pattern_password3 = "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}";
  //At least 8 characters in length Lowercase letters Uppercase letters Numbers Special characters
  pattern_password4 = "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}";

  unamePattern = "^[a-z0-9_-]{8,15}$";//Esempio

  buttonOnClass:any="my-ion-buttonOn";
  buttonOffClass:any="my-ion-buttonOff";
  
  
  //minAAAACal=1890;//ANNO MINIMO PER I CONTROLLI SULLA DATA
  //maxAAAACal=2050;//ANNO MASSIMO PER I CONTROLLI SULLA DATA

  minAAAACal="1800";
  maxAAAACal=new Date().getFullYear().toString();

  maxDataCal="2050-12-31";//DATA MASSIMA PER I CONTROLLI SULLA DATA per ION-DATETIME

  //minDatePicker="18900101";//DATA MASSIMA PER I CONTROLLI SULLA DATA per matDatepicker
  //maxDatePicker="20501231";//DATA MASSIMA PER I CONTROLLI SULLA DATA per matDatepicker

  minDatePicker = new Date(1890, 0, 1);
  maxDatePicker = new Date(2050, 11, 31);

  aster:String = '*';

  APIwsCdrisp:any;//impostato dalla risposta dell'Api
  APIwsDsrisp:any="";//impostato dalla risposta dell'Api

  //===MatDatepicker==============================================================
  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    //console.log("cellDate="+cellDate+" view="+view);//PIERO
    // Only highligh dates inside the month view.
    if (view === 'month') {
      var dt = new Date(cellDate);
      const date = dt.getDate();
      // Highlight the 1st and 20th day of each month.
      //return (date === 1 || date === 20) ? 'example-custom-date-class' : '';
      const day = dt.getDay();
      // Highlight Sunday.
      //console.log("Date="+Date+" d="+d+" day="+day);//PIERO
      return (day === 0) ? 'my-mat-highlight-dates' : undefined;
    }
    return '';
  }
  //==============================================================MatDatepicker===
  
  /*datePickerObj = {
    inputDate: new Date(), // default new Date()
    fromDate: new Date('1920-01-01'), // default null
    toDate: new Date('2050-12-31'), // default null
    closeOnSelect: true,
    mondayFirst: true,
    setLabel: 'Imposta',
    todayLabel: 'xxxxx',
    //todayLabel: this.getTranslation('Ionic4Datepicker.todayLabel'),
    closeLabel: 'Chiudi', // default 'Close'
    titleLabel: 'Imposta la Data',
    monthsList: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
    weeksList: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    dateFormat: 'DD/MM/YYYY',
    momentLocale: 'it-IT',
    clearButton : true,
    isSundayHighlighted :{
      fontColor: 'red'
    }
  };*/

  constructor(
    public alertController:AlertController,
    private translateService: TranslateService,//NGX-TRANSLATE
  ) { 

  }
 
  //Se il Form è stato modificato chiede il permesso di dismettere la maschera onde evitare la perdita dei dati digitati
  async TestChiudiModal(modalController: ModalController){
    const alert = await this.alertController.create({
      message: this.getTranslation('exprAskBack'),
      buttons: [
        {
          text: this.getTranslation('exprAskBackNo'),
          role: 'cancel',
          handler: blah => {
          },
        },
        {
          text: this.getTranslation('exprAskBackSi'),
          handler: () => {
            modalController.dismiss('C');//Dismette la maschera modale senza refresh della maschera chiamante
          }
        },
      ],
    });
    await alert.present();
  }

  //Tramuta un Flag proveniente dal DataBase in true/false
  checkboxDbToApp(value:any){
    let FlagAppCheckBox=false;
    if(value=="1"||value==true){FlagAppCheckBox=true;}
    return FlagAppCheckBox;
  }
  //Tramuta un Flag proveniente dall' App in "1"/""
  checkboxAppToDb(value:any){
    let FlagDbCheckBox="";
    if(value=="1"||value==true){FlagDbCheckBox="1";}
    return FlagDbCheckBox;
  }


  //===NGX-TRANSLATE=======================================================
  getTranslation(wordYouNeedToTranslate: string): string {
    return this.translateService.instant(wordYouNeedToTranslate);
  }

  setDefaultLanguage(language:string){
    this.translateService.setDefaultLang(language);
  }

  setLanguage(language:string){
    this.translateService.use(language);
  }

  getLanguage(){
    return this.translateService.currentLang;
  }
//=======================================================NGX-TRANSLATE===

  //custom validator to handle formats GG/MM/AAAA and GGMMAAAA
  dateValidator(minAAAA: string,maxAAAA: string): ValidatorFn {
    return(c: AbstractControl): { [key: string]: boolean } | null => {
      if (c.pristine) {return null;}
      if ((c.value !== undefined && c.value !== '' && c.value != null)) {
        var month = null;
        var day = null;
        var year = null;
        //formats GG/MM/AAAA
        if (c.value.length == 10) {
          if (c.value.indexOf('/') > -1) {
            var res = c.value.split("/");           
            if (res.length > 1) {
              day = res[0]
              month = res[1];
              year = res[2];
            }                              
          }
          if (c.value.indexOf('.') > -1) {
            var res = c.value.split(".");           
            if (res.length > 1) {
              day = res[0]
              month = res[1];
              year = res[2];
            }                              
          }
          if (c.value.indexOf('-') > -1) {
            var res = c.value.split("-");           
            if (res.length > 1) {
              day = res[0]
              month = res[1];
              year = res[2];
            }                              
          }
        }
        //formats GGMMAAAA DISATTIVATO
        //if (c.value.length == 8) {
        //  day = c.value.substring(0, 2);
        //  month = c.value.substring(2, 4);
        //  year = c.value.substring(4, 8);
        //}            
        if (isNaN(month) || isNaN(day) || isNaN(year)) {
          return { 'dateInvalid': true };
        } 
        month = Number(month);
        day = Number(day);
        year = Number(year);
        if (month < 1 || month > 12) { // check month range
          return { 'dateInvalid': true };
        }
        if (day < 1 || day > 31) {
          return { 'dateInvalid': true };
        }
        if ((month === 4 || month === 6 || month === 9 || month === 11) && day === 31) {
          return { 'dateInvalid': true };
        }
        if (month == 2) { // check for february 29th
          var isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
          if (day > 29 || (day === 29 && !isleap)) {
            return { 'dateInvalid': true };
          }
        }
        if(minAAAA!=""&&maxAAAA!=""){
          if (year < minAAAA||year > maxAAAA) {
            return { 'dateInvalid': true };
          }
        }
      }
      return null;
    }
  }

  dateValidatorMinMax(minAAAA: string,maxAAAA: string): ValidatorFn {
    return(c: AbstractControl): { [key: string]: boolean } | null => {
      if (c.pristine) {return null;}
      if ((c.value !== undefined && c.value !== '' && c.value != null)) {
        if (c.value.length != 4) {return { 'yearInvalid': true };}
        if (c.value<minAAAA||c.value>maxAAAA) {return { 'yearInvalid': true };}
      }
      return null;
    }
  }

  //Ionic4Datepicker Object Parameters
  SetdatePickerObj(){
    var datePickerObj={
      mode:'md',
      inputDate: new Date(), // default new Date()
      fromDate: new Date('1920-01-01'), // default null
      toDate: new Date('2050-12-31'), // default null
      closeOnSelect: true,
      mondayFirst: true,
      setLabel: this.getTranslation('Ionic4Datepicker.setLabel'),       // default 'Set'
      todayLabel: this.getTranslation('Ionic4Datepicker.todayLabel'),   // default 'Today'
      closeLabel: this.getTranslation('Ionic4Datepicker.closeLabel'),   // default 'Close'
      titleLabel: this.getTranslation('Ionic4Datepicker.titleLabel'),   // default ''
      monthsList: this.getTranslation('Ionic4Datepicker.monthsList'),
      weeksList: this.getTranslation('Ionic4Datepicker.weeksList'),
      dateFormat: this.getTranslation('Ionic4Datepicker.dateFormat'),
      momentLocale: this.getTranslation('Ionic4Datepicker.momentLocale'), // default 'en-US'
      clearButton : true,
      btnCloseSetInReverse: false,
      isSundayHighlighted :{
        fontColor: 'red'
      }
    }
    return datePickerObj;
  }

  gotoNextField(nextElement:any){
    nextElement.setFocus();
  }

  //Elenca il contenuto di un Oggetto
  displayObject(obj:object){
    var dispobj = '';
    for (var property in obj) {
      dispobj += property + ': ' + obj[property]+'; ';
    }
    return dispobj;
  }

  progressPercentage:any ="0.00";
  progressPerc:any;


}
